export const JUMIO_HAVE_COPY_ID_FAX_KEY = 145;

export const JUMIO_HAVE_COPY_ID_FAX_VALUE = {
    VERIFIED: '1'
    // NOT_VERIFIED: '0'
};

export const JUMIO_TAG_NAME = 'risk/doc/upload_requirement';

export const JUMIO_VERIFICATION_STATUS = {
    VERIFIED: 'verified',
    PENDING: 'pending',
    NOT_VERIFIED: 'notVerified'
};

export const ICON_TYPE_TO_STATUS_MAP = {
    pending: 'pending',
    verified: 'success',
    notVerified: 'attention'
};
